import o from "./_arrayReduce.js";
import t from "./deburr.js";
import p from "./words.js";
var u = "['’]", a = RegExp(u, "g");
function c(r) {
  return function(e) {
    return o(p(t(e).replace(a, "")), r, "");
  };
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_createCompounder.js
// module id = 1464
// module chunks = 41